import { createSlice } from "@reduxjs/toolkit";
import {
  getPredictionsLengthAsync,
  getPromisesLengthAsync,
  getPredictorsLengthAsync,
  getSurveysLengthAsync,
} from "./actions";

const initialState = {
  isLoading: true,
  predictionsLength: 0,
  promisesLength: 0,
  predictorsLength: 0,
  surveysLength: 0,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPredictionsLengthAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPredictionsLengthAsync.fulfilled, (state, action) => {
        state.predictionsLength = action.payload;
        state.isLoading = false;
      })
      .addCase(getPredictionsLengthAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.predictionsLength = 0;
      })
      .addCase(getPromisesLengthAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPromisesLengthAsync.fulfilled, (state, action) => {
        state.promisesLength = action.payload;
        state.isLoading = false;
      })
      .addCase(getPromisesLengthAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.promisesLength = 0;
      })
      .addCase(getPredictorsLengthAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPredictorsLengthAsync.fulfilled, (state, action) => {
        state.predictorsLength = action.payload;
        state.isLoading = false;
      })
      .addCase(getPredictorsLengthAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.predictorsLength = 0;
      })
      .addCase(getSurveysLengthAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSurveysLengthAsync.fulfilled, (state, action) => {
        state.surveysLength = action.payload;
        state.isLoading = false;
      })
      .addCase(getSurveysLengthAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.surveysLength = 0;
      });
  },
});

export default dashboardSlice.reducer;
